function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-product"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "product",
  clipPath: "url(#clip-product)"
}, /*#__PURE__*/React.createElement("g", {
  id: "product-2",
  "data-name": "product"
}, /*#__PURE__*/React.createElement("rect", {
  id: "area",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "product-3",
  "data-name": "product",
  d: "M1.75,16.711A1.751,1.751,0,0,1,0,14.962v-9C0,5.382,2.968.65,2.968.65A.831.831,0,0,1,3.022.57.75.75,0,0,1,3.749,0h12a.749.749,0,0,1,.727.566.758.758,0,0,1,.047.072C18.777,4.54,19.5,5.382,19.5,5.962v9a1.752,1.752,0,0,1-1.751,1.75ZM1.5,5.962v9a.25.25,0,0,0,.249.25h16a.251.251,0,0,0,.25-.25v-9a.251.251,0,0,0-.25-.25H13.5v5a.747.747,0,0,1-.174.481c-.011.023-.023.046-.035.069a.75.75,0,0,1-1.025.274L9.8,10.111,7.157,11.636a.75.75,0,0,1-1.023-.274.742.742,0,0,1-.1-.427A.761.761,0,0,1,6,10.712v-5H1.75A.25.25,0,0,0,1.5,5.962Zm6-.25V9.706L9.265,8.687l.017-.01a.75.75,0,0,1,.876-.09L12,9.65V5.711Zm9.355-1.5L15.29,1.5H4.209L2.644,4.211Z",
  transform: "translate(2.25 4.039)"
})));

var SvgProduct = function SvgProduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product.963fae10.svg";
export { ForwardRef as ReactComponent };